<template>
    <tr>
        <td class="text-center">
            <span class="ix-drag-icon handle-line"></span>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" placeholder="jj/mm/aaaa" :name="'lines[' + index + '][payed_at]'" v-model="line.payed_at" :id="'datepicker' + line.uniq">
            <div v-if="lineError && lineError['lines.' + index + '.payed_at']" class="ix-text-red">
                {{ lineError['lines.' + index + '.payed_at'][0] }}
            </div>
        </td>
        <td>
            <input class="form-control form-control-sm" type="text" :name="'lines[' + index + '][company_name]'" v-model="line.company_name" @input="emitEeventLineEdited" :required="(line.payed_at != '' && line.payed_at != null) || line.users.length > 0" :id="'companyAutocomplete' + line.uniq">
            
            <button type="button" tabindex="-1" class="ix-btn link" @click="manageUsers()">
                <i class="far fa-chevron-right"></i> Accompagnateurs
                <span v-if="line.users.length > 0">({{ line.users.length }})</span>
            </button>

            <input type="hidden" :name="'lines[' + index + '][id]'" v-model="line.id">
            <input type="hidden" :name="'lines[' + index + '][index]'" v-model="index">
            <input type="hidden" :name="'lines[' + index + '][company_id]'" v-model="line.company_id">
            <input type="hidden" :name="'lines[' + index + '][deal_id]'" v-model="line.deal_id">
            <input type="hidden" :name="'lines[' + index + '][total_ht]'" v-model="line.total_ht">

            <div v-for="(user, i) in line.users">
                <input type="hidden" :name="'lines[' + index + '][users][' + i + '][id]'" v-model="user.id">
                <input type="hidden" :name="'lines[' + index + '][users][' + i + '][fullname]'" v-model="user.fullname">
            </div>

            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" placeholder="description, informations complémentaires, .." :name="'lines[' + index + '][description]'" v-model="line.description"></textarea>
                <input class="form-control form-control-sm mt-2" type="text" :name="'lines[' + index + '][deal_designation]'" v-model="line.deal_designation" :id="'dealAutocomplete' + line.uniq" placeholder="Affecter à une affaire">
            </div>
        </td>

        <td>
            <select :name="'lines[' + index + '][type]'" v-model="line.type" class="form-control form-control-sm" :required="(line.payed_at != '' && line.payed_at != null)">
                <optgroup :label="category" v-for="(array, category) in types">
                    <option v-for="(type, value) in array" :value="value">{{ type.short_label }}</option>
                </optgroup>
            </select>

            <input class="form-control form-control-sm mt-2" type="text" :name="'lines[' + index + '][type_other]'" v-model="line.type_other" v-show="line.type == 0" placeholder="Précisez" :required="line.type == 0 && (line.payed_at != '' && line.payed_at != null)">
        </td>
        <td class="text-center">
            <input type="checkbox" v-model="line.pro" :name="'lines[' + index + '][pro]'" value="1">
        </td>
        <td>
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'lines[' + index + '][total_ttc]'" v-model="line.total_ttc" @blur="compute" :required="(line.payed_at != '' && line.payed_at != null)" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                </div>
            </div>
        </td>
        <td>
            <div class="input-group input-group-sm">
                <input type="number" class="form-control text-right" :name="'lines[' + index + '][total_vat]'" v-model="line.total_vat" @blur="compute" :required="(line.payed_at != '' && line.payed_at != null)" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                </div>
            </div>
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";

    export default {
        name: 'expense-report-line-form',
        props: ['line', 'index', 'companiesRoute', 'dealsRoute', 'types', 'lineError'],
        data() {
            return {
                errors: [],
                is_expanded: false,
            };
        },
        methods : {
            manageUsers(){
                this.$emit('line-manage-users-started', this.index)
            },
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            compute: function() {
                if (this.line.total_ttc == '' || this.line.total_ttc == null) { this.line.total_ttc = 0 }
                if (this.line.total_vat == '' || this.line.total_vat == null) { this.line.total_vat = 0 }

                this.line.total_ht = parseFloat(this.line.total_ttc) - parseFloat(this.line.total_vat);
            },
            emitEeventLineEdited: function () {
                this.$emit('line-editing-started', this.index)
            },
            emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('line-deleted', this.index)
                    }
                })
            }
        },
        mounted() {
            if (this.line.description) {
                this.is_expanded = true;
            }

            this.compute()

            $("#datepicker" + this.line.uniq).datepicker({
                format: "dd/mm/yyyy",
                todayBtn: true,
                language: "fr",
                calendarWeeks: true,
                autoclose: true,
                todayHighlight: true,
                clearBtn: false,
            })

            $("#datepicker" + this.line.uniq).change(function() {
                $(this)[0].dispatchEvent(new Event('input'));
            });

            $("#companyAutocomplete" + this.line.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.companiesRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.name,
                                    value: item.name,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        this.line.company_id = null
                    }
                },
                select: (e, item) => {
                    this.line.company_id = item.item.id
                    this.line.company_name = item.item.name
                }
            }).focus(() => {
                $("#companyAutocomplete" + this.line.uniq).autocomplete("search", '');
            });

            $("#dealAutocomplete" + this.line.uniq).autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.dealsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        this.line.deal_designation = null
                        this.line.deal_id = null
                    }
                },
                select: (e, item) => {
                    this.line.deal_id = item.item.id
                    this.line.deal_designation = item.item.designation
                }
            }).focus(() => {
                $("#dealAutocomplete" + this.line.uniq).autocomplete("search", '');
            });
        }
    }
</script>
